import React from 'react';
import { Button, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

export function PredefinedRangeDatePickerValues({ onValueChange }) {
  const { t } = useTranslation();

  return (
    <Row align={'middle'} gutter={[8, 8]} wrap>
      <Col>
        <span>{t('Nastaviť rozsah na')}</span>
      </Col>
      {[
        { value: 3, label: t('3 dni') },
        { value: 5, label: t('5 dní') },
        { value: 7, label: t('7 dní') },
        { value: 14, label: t('14 dní') },
      ].map(({ value, label }) => (
        <Col key={value}>
          <Button
            onClick={() => {
              onValueChange([dayjs().subtract(value, 'day'), dayjs()]);
            }}
          >
            {label}
          </Button>
        </Col>
      ))}
    </Row>
  );
}
